import ACL_RELATIONSHIPS from "acl-relationships";
import { TableCreateButton } from "components/BaseTableV3/TableCreateButton";
import { useCampaignNavigation } from "routes/campaign/useCampaignNavigation";

const CREATE_ACLS = [
  ACL_RELATIONSHIPS.campaign.create,
  ACL_RELATIONSHIPS.campaignStatusPreset.read,
];

/** The Campaigns table's create action. */
const NewCampaignButton = () => {
  const { openCreate } = useCampaignNavigation();

  return (
    <TableCreateButton permissions={CREATE_ACLS} onClick={openCreate}>
      New Campaign
    </TableCreateButton>
  );
};

export default NewCampaignButton;
